// extracted by mini-css-extract-plugin
export default {"content":"ContentCenter_content__nuaFI"};